import { hashObject } from './object.js';

/**
 * Hashing the procedure for supply configuration requires that the taskID and products are the same
 */

const hashProcedureForSupplyConfig = procedure => {
  const distinctKeys = ['dropOffPlaceGroups', 'products', 'taskID'];
  const arrayToHash = distinctKeys.map(key => {
    const value = procedure[key];
    if (typeof value === 'object') return Object.keys(value);
    return value;
  });
  return hashObject(arrayToHash);
};

export { hashProcedureForSupplyConfig };
